import { LitElement, html, css } from 'lit'

customElements.define('bui-logo', class extends LitElement{

    static get styles(){return css`
        :host {
            display: inline-flex;
            font-size: var(--size, 2em);
            height: .7em;
            align-items: center;
            color: var(--theme-text);
            user-select: none;
        }

        svg {
            height: .62em;
            margin: -0.25em 0em -0.17em;
        }

        svg * {
            fill: currentColor;
        }

        span {
            /* color: currentColor; */
            color: var(--theme);
            /* opacity: .4; */
            font-size: .9em;
            line-height: 0;
            margin-top: -.07em;
        }
    `}

    render(){return html`
     
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
     height="256.000000pt" viewBox="0 0 247.000000 256.000000"
     preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,256.000000) scale(0.100000,-0.100000)"
    fill="#000000" stroke="none">
    <path d="M481 2384 c-17 -14 -35 -42 -41 -62 -6 -24 -10 -387 -10 -1042 0
    -1138 -6 -1055 80 -1097 l45 -22 563 6 563 6 15 28 c19 38 18 52 -7 75 -20 18
    -43 19 -580 17 l-559 -2 0 962 c0 529 -3 979 -6 1000 l-7 37 170 0 c93 0 305
    -3 471 -7 l302 -6 0 -238 c0 -218 1 -239 19 -260 19 -24 20 -24 270 -27 l251
    -3 0 -93 c0 -101 8 -118 62 -131 19 -5 32 -1 46 13 19 19 20 31 17 151 -3 89
    -9 140 -19 159 -8 16 -139 149 -290 295 l-275 267 -525 0 -524 0 -31 -26z
    m1284 -344 l160 -160 -162 0 -162 0 -3 160 c-2 88 -1 160 2 160 3 0 77 -72
    165 -160z"/>
    <path d="M756 1971 c-20 -23 -21 -75 0 -95 13 -14 54 -16 289 -16 272 0 274 0
    289 22 22 31 20 64 -4 88 -20 20 -32 20 -289 19 -243 0 -271 -2 -285 -18z"/>
    <path d="M750 1621 c-14 -28 -13 -53 6 -79 l15 -22 419 0 420 0 16 25 c13 20
    15 33 7 58 l-9 32 -431 3 c-419 2 -432 2 -443 -17z"/>
    <path d="M1800 1419 c-212 -42 -370 -277 -326 -488 19 -90 30 -110 204 -379
    82 -125 158 -243 170 -263 34 -57 49 -65 72 -44 11 10 73 102 137 204 64 102
    142 225 173 272 77 117 93 173 88 302 -5 124 -31 189 -107 270 -107 113 -252
    157 -411 126z m187 -223 c124 -58 156 -211 65 -317 -44 -51 -84 -69 -158 -69
    -181 0 -268 216 -139 345 67 67 145 81 232 41z"/>
    <path d="M756 1294 c-21 -20 -20 -78 1 -95 22 -19 467 -24 504 -6 35 18 46 59
    25 91 l-16 26 -250 0 c-213 0 -251 -2 -264 -16z"/>
    <path d="M1088 813 l-147 -147 -60 63 c-55 59 -62 63 -92 57 -35 -7 -58 -30
    -59 -60 0 -10 39 -61 86 -112 89 -98 108 -108 157 -83 12 6 95 84 185 172 142
    142 162 166 162 194 0 35 -29 63 -65 63 -13 0 -74 -54 -167 -147z"/>
    </g>
    </svg>

    `}


    //render() {
    //    return html`

    //    <span>❮</span>

    //    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126.62 188.42"><g style="fill:var(--logo-color, #1d1d1b);" id="Layer_2" data-name="Layer 2"><g id="Layer_4" data-name="Layer 4"><path d="M10.74,7.1c13.2-11.54,67.06-9.34,91.22,9,26.1,19.84,23,55.15-10.4,70C58.68,100.82,15.41,110.5,5.79,73.75-5,32.53.83,15.78,10.74,7.1Z"/><path d="M126.62,139.29c-.19,42.87-26.55,46.48-58.42,48.35-39.92,2.35-56.14,1-59.76-26.42-3.35-25.31,8.51-37,50.23-51.35C113.14,91.08,126.76,107.25,126.62,139.29Z"/></g></g></svg>

    //    <span>❯</span>
    //`}
})

export default customElements.get('bui-logo')